import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import Button from '../Button/Button.js';
import '../Button/SplitButton.js';
import { CirclesContainer, LINE_POSITIONS, Spinner } from '../Spinner/index.js';

const BackDrop = styled(Backdrop) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1;
`;
const _Typography = styled(MuiTypography) `
  margin: ${({ theme }) => theme.spacing(4.5, 0, 4, 0)};
  color: ${({ theme }) => theme.palette.N10.main};
  user-select: none;
`;
const ScreenLoader = (_a) => {
    var { loading, loadingLabel = 'Loading...', cancelButtonLabel = 'Cancel', onCancel } = _a, rest = __rest(_a, ["loading", "loadingLabel", "cancelButtonLabel", "onCancel"]);
    return (jsxs(BackDrop, Object.assign({ open: loading }, rest, { children: [jsx(CirclesContainer, { children: LINE_POSITIONS.map(linePosition => (jsx(Spinner, { linePosition: linePosition }, linePosition))) }), loadingLabel && jsx(_Typography, Object.assign({ variant: "h5" }, { children: loadingLabel })), onCancel && cancelButtonLabel && (jsx(Button, Object.assign({ variant: "text", size: "medium", "data-testid": "cancel-button", onClick: onCancel }, { children: cancelButtonLabel })))] })));
};

export { ScreenLoader as default };
//# sourceMappingURL=ScreenLoader.js.map
